// §11.1 — Explorer's own cut/copy/paste of *files*.
//
// Not §10.1's clipboard: that one carries content between apps, is shell-owned, and its reads
// are gesture-gated (it arrives in M9.2). This is a list of paths one Explorer window pended and
// another can complete — module state, so every window of the built-in shares it, and nothing
// leaves the app.
import type { VfsPath } from '@hangar/shared';

export interface FileClip {
  mode: 'copy' | 'cut';
  paths: readonly VfsPath[];
}

let clip: FileClip | null = null;
const listeners = new Set<() => void>();

export function getClip(): FileClip | null {
  return clip;
}

export function setClip(next: FileClip | null): void {
  clip = next && next.paths.length > 0 ? { mode: next.mode, paths: [...next.paths] } : null;
  for (const listener of [...listeners]) listener();
}

export function subscribeClip(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
